module.exports = __webpack_public_path__ + "static/media/token-usdt.5e1fc6c2.svg";